import * as React from 'react'

const SvgTimeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 19c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zm0-16.7c-4.3 0-7.7 3.5-7.7 7.7s3.5 7.7 7.7 7.7 7.7-3.5 7.7-7.7-3.4-7.7-7.7-7.7zm3 11.6l-3.6-3.6V4h1.2v5.7l3.3 3.3-.9.9z"
      fill="#163250"
    />
  </svg>
)

export default SvgTimeIcon
